// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"2441":"fc741cf57e9647f370a3","5266":"92742106cfd0ab7e96b2","5862":"7b9b02dc0a1b898066ef","7874":"5d0f14697282cbdd7841","8320":"87233c1e751a74de3fe2","9087":"1cf9a75e405a9fdd8324"}[chunkId] + "";
};